import * as React from "react"

const SvgNewspaper = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M4 21.714q-.824 0-1.413-.587A1.93 1.93 0 0 1 2 19.714v-15.4q0-.175.15-.237.15-.063.275.062l1.25 1.25 1.3-1.325a.48.48 0 0 1 .7 0L7 5.39l1.325-1.325a.48.48 0 0 1 .7 0l1.3 1.325 1.325-1.325a.48.48 0 0 1 .7 0l1.325 1.325 1.3-1.325a.48.48 0 0 1 .7 0L17 5.39l1.325-1.325a.48.48 0 0 1 .7 0l1.3 1.325 1.25-1.25q.125-.125.275-.062.15.062.15.237v15.4a1.93 1.93 0 0 1-.587 1.413 1.93 1.93 0 0 1-1.413.587H4Zm0-2h7v-6H4zm9 0h7v-2h-7zm0-4h7v-2h-7zm-9-4h16v-3H4z" />
  </svg>
)
export default SvgNewspaper
